import { Component, OnInit } from '@angular/core';
import { ParentService } from '../parent.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent implements OnInit {
  isChecked = false;
  show = true;
  accountdeletedetails: any;
  constructor(private dialogRef: MatDialogRef<DeleteDialogComponent>, private loginService: ParentService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {

  }
  onCheckboxChange() {
    console.log(this.isChecked);
  }

  dialogclose() {
    this.dialogRef.close();
  }

  success() {
    this.spinner.show();
    const admNo = localStorage.getItem('admNo');
    const deviceSessionId = localStorage.getItem('deviceSessionId')
    this.loginService.accountDelete(admNo, deviceSessionId).subscribe(
      {
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
          }
          this.spinner.hide();
          this.accountdeletedetails = res;
          this.show = !this.show;
        },
        error: (err: any) => {
          this.spinner.hide();
        }

      })
  }

  submit() {
    this.dialogRef.close();
  }



}
